import React from 'react'
import { useAuth } from '@nic/kc-auth'
import { Header } from './Components/Layout/Header'
import { AbilityProvider } from '@nic/commons'
import { usersAbilities } from './setupAbilites'
import { LayoutManager } from './Context/LayoutContext'
import { Footer } from './Footer'
import { StateOrProvinceProvider } from '@nic/ui-antd/build/StateOrProvince'
import { SelectUserProvider } from './Components/Providers/SelectedUserContext'
import { Routes } from './Routes'
import { NicScope } from '@nic/nic-api/types'

export const InnerApp: React.FC = () => {
  const { keycloak } = useAuth() // Recupera il client dal contest
  const HeaderMemo = React.memo(Header)

  if (keycloak) {
    return (
      <AbilityProvider restrictions={usersAbilities} keycloak={keycloak}>
        <LayoutManager
          header={<HeaderMemo title={<span style={{ fontSize: '2.0rem' }}>darwin</span>} />}
          body={<Body />}
          footer={<Footer />}
        />
      </AbilityProvider>
    )
  } else {
    return <div>Authenticating...</div>
  }
}


/**
 * Inserito questo componente perchè c'è da controllare che il token di KC
 * sia arrivato altrimenti StateOrProvince va in errore 401 perchè troppo veloce
 * e ancora senza token ...anche se in verità dovrebbe già averlo a bordo (da capire perchè
 * viene eseguito prima
 * TODO: C'è da capire come migliorare
 * */
function Body() {
  const { keycloak } = useAuth()

  return keycloak?.authenticated ? (
    <>
      <StateOrProvinceProvider scope={keycloak.realm as NicScope}>
        <SelectUserProvider>
          <Routes />
        </SelectUserProvider>
      </StateOrProvinceProvider>
    </>
  ) : (
    <>There is some problem with the authorization token</>
  )
}
